import { render, staticRenderFns } from "./lend.vue?vue&type=template&id=1a96993a"
import script from "./lend.vue?vue&type=script&lang=js"
export * from "./lend.vue?vue&type=script&lang=js"
import style0 from "./lend.vue?vue&type=style&index=0&id=1a96993a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports